import { render, staticRenderFns } from "./HomeFooter.vue?vue&type=template&id=6dd70fd2&scoped=true&"
import script from "./HomeFooter.vue?vue&type=script&lang=js&"
export * from "./HomeFooter.vue?vue&type=script&lang=js&"
import style0 from "./HomeFooter.vue?vue&type=style&index=0&id=6dd70fd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd70fd2",
  null
  
)

export default component.exports